import { Button, Divider, Grid, MenuItem, Select, theme, Typography } from "@mzc-pdc/ui";
import compareVersions, { VERSION_CM_11330_USERS_TEAMS_ACCESS_V3 } from "@cores/version";
import { UsersMultiInputV2 } from "@features/users-input/users-multi-input-v2";
import { UsersMultiInput } from "@features/users-input/users-multi-input";
import { IconAdd } from "@mzc-cloudplex/icons";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const UsersInputWithTemporarySave = ({
    title,
    showCount,
    selecting,
    selected,
    actionProps,
    addButtonLabel,
    onChangeSelecting,
    onClickAddToSelected,
    userScope,
}) => {
    const { t } = useTranslation();

    const stage = useSelector(({ stage }) => stage);

    return (
        <Grid container flexDirection={"column"} gap={theme.spacing(1)}>
            <Grid item>
                <Typography variant={`body1_500`}>{t(`common::label::${title}`, title)}</Typography>&nbsp;
                {showCount && (
                    <Typography variant={`body1_500`} color={theme.palette.primary.main}>
                        {selecting?.length ?? 0}
                    </Typography>
                )}
            </Grid>
            <Grid
                item
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: theme.spacing(1),
                    alignItems: "flex-end",
                }}
            >
                {compareVersions(stage.version, VERSION_CM_11330_USERS_TEAMS_ACCESS_V3) >= 0 ? (
                    <UsersMultiInputV2
                        users={selecting}
                        exceptUsers={selected.concat(selecting)}
                        sx={{
                            flex: 3,
                            "& .MuiOutlinedInput-root": {
                                paddingRight: "0px !important",
                            },
                        }}
                        placeholder={t(`common::msg::Please enter user's name.`, `Please enter user's name.`)}
                        onChange={onChangeSelecting}
                        scope={userScope}
                    />
                ) : (
                    <UsersMultiInput
                        users={selecting}
                        exceptUsers={selected.concat(selecting)}
                        sx={{
                            flex: 3,
                            "& .MuiOutlinedInput-root": {
                                paddingRight: "0px !important",
                            },
                        }}
                        placeholder={t(`common::msg::Please enter user's name.`, `Please enter user's name.`)}
                        onChange={onChangeSelecting}
                    />
                )}
                {actionProps && (
                    <Select
                        onChange={(e) => {
                            actionProps.setAction && actionProps.setAction(e.target.value);
                        }}
                        value={actionProps.action}
                        sx={{ flex: `1 0 0%`, height: "100%" }}
                    >
                        {actionProps.actionOptions?.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {t(`common::label::${option.label}`, `${option.label}`)}
                            </MenuItem>
                        ))}
                    </Select>
                )}
            </Grid>
            <Grid
                item
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    my: theme.spacing(0.5),
                }}
            >
                <Button
                    size={"small"}
                    variant={"text"}
                    disabled={selecting.length === 0}
                    onClick={onClickAddToSelected}
                    startIcon={<IconAdd size={16} />}
                >
                    {t(`common::label::${addButtonLabel}`, addButtonLabel)}
                </Button>
            </Grid>
        </Grid>
    );
};

export default UsersInputWithTemporarySave;
